module.exports = __webpack_public_path__ + "img/motorway_6x1_z16.4c2b4b89.svg";